import { apiClient } from './client';

// One runtime feature flag, resolved for the current user (registry default
// merged with that user's override). The catalog lives on the API — the web
// just renders whatever it returns.
export interface FeatureFlag {
  key: string;
  label: string;
  enabled: boolean;
}

export const featureFlagsApi = {
  async list(): Promise<FeatureFlag[]> {
    const response = await apiClient.get<{ flags: FeatureFlag[] }>('/feature-flags');
    return response.data.flags;
  },

  // Toggles a flag for the CURRENT user (admin-only on the server). Returns the
  // updated resolved list.
  async setFlag(key: string, enabled: boolean): Promise<FeatureFlag[]> {
    const response = await apiClient.patch<{ flags: FeatureFlag[] }>(
      `/feature-flags/${key}`,
      { enabled },
    );
    return response.data.flags;
  },
};
